import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HorrorService } from '@services/horror.service'; // adjust path

export const cherishGuard: CanActivateFn = (route, state) => {
  const horrorService = inject(HorrorService);
  const router = inject(Router);

  if (horrorService.isCherishAuthorized()) {
    return true;
  }

  return router.createUrlTree(['/wp-login.php']);
};
